module.exports = __webpack_public_path__ + "img/qualityFactors@2x.61e363a.webp";